import { Node, mergeAttributes } from '@tiptap/core'

/**
 * Chord extension implementing Chords as an inline, atomic, and draggable Node.
 * This enables native, robust drag-and-drop support in ProseMirror without selection conflicts.
 */
export const Chord = Node.create({
  name: 'chord',
  group: 'inline',
  inline: true,
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      chord: {
        default: '',
        parseHTML: element => {
          const span = element.querySelector('.chord-span') || element.querySelector('.chord-item');
          const innerText = (span ? span.textContent : element.textContent || '').trim();
          const attrChord = element.getAttribute('data-chord') || element.getAttribute('chord') || element.getAttribute('data-chord-name') || (span ? (span.getAttribute('data-chord') || span.getAttribute('chord')) : '');
          
          if (innerText && !/\s/.test(innerText)) {
            return innerText;
          }
          if (attrChord && !/\s/.test(attrChord)) {
            return attrChord;
          }
          return innerText || attrChord || '';
        },
        renderHTML: attributes => ({
          'data-chord': attributes.chord,
        }),
      },
      spacer: {
        default: '',
        parseHTML: element => element.getAttribute('data-spacer') || '',
        renderHTML: attributes => {
          if (!attributes.spacer) return {};
          return {
            'data-spacer': attributes.spacer,
          };
        }
      }
    }
  },

  parseHTML() {
    return [
      { tag: 'sup[data-type="chord"]' },
      { tag: 'sup.chord-sup' },
      { tag: 'span.chord-container' },
      { tag: 'span.chord-item' },
      { tag: 'b[data-chord-name]', priority: 100 },
      { 
        tag: 'b',
        priority: 50,
        getAttrs: element => {
          if (element.closest('sup.chord-sup') || element.closest('.chord-container') || element.closest('.chord-span')) {
            return false;
          }
          const text = (element.textContent || '').trim();
          const chordRegex = /^[A-G][b#]?(m|M|min|maj|dim|aug|sus|add|arr)?[0-9]*(M|maj)?(\+[0-9]*)?(\/[A-G][b#]?)?$/;
          if (chordRegex.test(text)) {
            return null; // Match
          }
          return false; // Don't match
        }
      },
    ]
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      'sup',
      mergeAttributes(HTMLAttributes, { 'data-type': 'chord', class: 'chord-sup' }),
      ['span', { class: 'chord-span', contenteditable: 'false', draggable: 'true' }, node.attrs.chord],
    ]
  },

  addCommands() {
    return {
      toggleChord: (chordName = 'C') => ({ commands }) => {
        return commands.insertContent({
          type: this.name,
          attrs: { chord: chordName }
        })
      },
    }
  }
})
